import Cookies from "js-cookie";

export default class GDPR {
  constructor() {
    this.cookieName = "sf_gdpr_accept";

    // Handle iOS user agent
    if (window.iosDisableTracking) {
      this.acceptEssential();
      return;
    }

    this.$gdpr = document.querySelector(".c-gdpr");
    if (!this.$gdpr) return;

    this.$buttonAll = this.$gdpr.querySelector(".c-button.js-cookie-all");
    this.$buttonEssential = this.$gdpr.querySelector(
      ".c-button.js-cookie-essential",
    );

    this.$buttonAll.addEventListener("click", this.acceptAll.bind(this));
    this.$buttonEssential.addEventListener(
      "click",
      this.acceptEssential.bind(this),
    );

    this.check();
  }

  /**
   * @function check
   * Checks if the GDPR acceptance cookie exists
   * and conditionally shows the popup
   */
  check() {
    const existingCookie = Cookies.get(this.cookieName);
    if (!existingCookie) {
      this.$gdpr.classList.add("is-visible");
    } else {
      this.$gdpr.remove();

      if (existingCookie === "essential") {
        this.acceptEssential();
      } else {
        this.acceptAll();
      }
    }
  }

  acceptBanner(value) {
    Cookies.set(this.cookieName, value);
    localStorage.setItem(this.cookieName, value);
    this.$gdpr?.remove();
  }

  /**
   * @function acceptAll
   */
  acceptAll() {
    this.acceptBanner("all");
    if (window.rudderanalytics) {
      window.rudderanalytics.load(
        "2euGxA896ZvjnQtB45KdliGZObe",
        "https://seatfrogsystems.dataplane.rudderstack.com",
        {},
      );
    }

    if (window.gtag) {
      console.log("Running gtag events");
      gtag("js", new Date());
      gtag("config", "G-4L2QB9XCRS");
      gtag("consent", "default", {
        analytics_storage: "granted",
      });
    }

    if (window.fbq) {
      fbq("track", "PageView");
    }
  }

  /**
   * @function acceptEssential
   */
  acceptEssential() {
    this.acceptBanner("essential");

    const cookiesToRemove = [
      "handl_ip",
      "handl_landing_page",
      "handl_original_ref",
      "handl_ref",
      "handl_url",
      "utm_campaign",
      "utm_medium",
      "utm_source",
    ];

    setTimeout(() => {
      cookiesToRemove.forEach((cookie) => {
        Cookies.remove(cookie, {
          domain: ".seatfrog.com",
        });

        Cookies.remove(cookie);
      });
    }, 1000);
  }
}
